module.exports = __webpack_public_path__ + "static/media/img02.8e16cf4f.jpg";